import React from 'react';
import PropTypes from 'prop-types';

const PdxNavPanelSectionHeader = ({ children }) => (
  <div className="pdx-nav-panel-section-header">{children}</div>
);

PdxNavPanelSectionHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]).isRequired
};

export default PdxNavPanelSectionHeader;
